import ky from 'ky';
import type { Options } from 'ky';

const baseURL = import.meta.env.VITE_APP_API_URL || 'http://localhost:3000/api';

interface StreamConfig extends Options {
  onChunk?: (chunk: string) => void;
}

const api = ky.create({
  prefixUrl: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    // 'Authorization': `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiZW1haWwiOiJ0ZXN0QGRvbWFpbi5jb20iLCJpYXQiOjE3NDE2NjY2NzgsIm5iZiI6MTc0MTY2NjY3OCwiZXhwIjoxNzQyMjcxNDc4LCJzdWIiOiJ0ZXN0QGRvbWFpbi5jb20ifQ.r-AYXuVd0skQS-UAUGfdSnVV3gGPv_u1ijV6hDMapu5UXirWOdGBQf67o34JuebolN-1Ng33MoFu_FGfYx-Bq87A2GttkjsVoBSm01IfHb9M1q4bNHQeztlSKrSgxXszibMs1645aT-7wkUzWh2OWeERs1OLSjXmVmRh_3WXzubTAp1oX4ijA5c8LNCRJlhdg5ZH1efbVars3CdZmp0AaxH3g6iUtDrswaLmuYMTPNPGNHrNIHT2GBiK3dIQ9r5OhAt5HCw7SnE7TUMmZoQBPJW4M9yFDKdX8rJ2Gy0b_LOvY0TmZrSwEC3xCginqhjxQ-3HhPZr_-NJG9_K2mdQHA`,
  },
  timeout: 100000,
});

export const apiClient = {
  get: async <T>(url: string, options?: Options): Promise<T> => {
    return api.get(url, options).json<T>();
  },

  post: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.post(url, { json: data, ...options }).json<T>();
  },

  put: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.put(url, { json: data, ...options }).json<T>();
  },

  patch: async <T>(url: string, data?: unknown, options?: Options): Promise<T> => {
    return api.patch(url, { json: data, ...options }).json<T>();
  },

  delete: async <T>(url: string, options?: Options): Promise<T> => {
    return api.delete(url, options).json<T>();
  },

  postStream: async <T>(url: string, data?: unknown, config?: StreamConfig): Promise<T> => {
    const response = await api.post(url, {
      json: data,
      headers: {
        'Accept': 'text/event-stream',
        'X-Accel-Buffering': 'no'
      }
    });

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();

    while (reader) {
      const { done, value } = await reader.read();
      if (done) break;
      
      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');
      lines.forEach(line => {
        if (line.trim()) {
          config?.onChunk?.(line);
        }
      });
    }

    return {} as T;
  },
};

export default api;
